export const categories = [
  { id: 1, name: '恋爱', slug: 'romance', icon: 'ri-heart-line', count: 1280 },
  { id: 2, name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', count: 960 },
  { id: 3, name: '动作', slug: 'action', icon: 'ri-sword-line', count: 850 },
  { id: 4, name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line', count: 620 },
  { id: 5, name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line', count: 740 },
  { id: 6, name: '古风', slug: 'historical', icon: 'ri-ancient-gate-line', count: 430 },
  { id: 7, name: '惊悚', slug: 'thriller', icon: 'ri-ghost-line', count: 380 },
  { id: 8, name: '治愈', slug: 'healing', icon: 'ri-empathize-line', count: 510 },
  { id: 9, name: '热血', slug: 'shounen', icon: 'ri-fire-line', count: 670 },
  { id: 10, name: '日常', slug: 'slice-of-life', icon: 'ri-sun-line', count: 450 },
];

export const comics = [
  {
    id: 1,
    title: '霸道总裁爱上我',
    author: '金秀妍',
    category: '恋爱',
    categorySlug: 'romance',
    status: '连载中',
    rating: 9.2,
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20illustration%20featuring%20a%20handsome%20CEO%20in%20a%20luxurious%20office%20setting%20with%20romantic%20lighting%2C%20elegant%20gold%20accents%2C%20soft%20warm%20tones%2C%20modern%20fashionable%20style%2C%20clean%20composition%20on%20neutral%20background%2C%20digital%20art%20style%20with%20soft%20shadows&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '平凡女孩林小雨意外进入顶尖企业实习，却不知道自己早已被年轻有为的总裁默默关注。一场啼笑皆非的职场爱情故事就此展开...',
    tags: ['总裁', '职场', '甜蜜', '反差萌'],
    chapters: 86,
    updateDate: '2026-08-01',
    views: 1580000,
  },
  {
    id: 2,
    title: '重生之绝世剑神',
    author: '李东旭',
    category: '奇幻',
    categorySlug: 'fantasy',
    status: '连载中',
    rating: 9.5,
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20fantasy%20manhwa%20cover%20with%20a%20powerful%20warrior%20holding%20a%20glowing%20magical%20sword%2C%20dramatic%20epic%20fantasy%20atmosphere%2C%20dark%20mystical%20background%20with%20blue%20and%20gold%20energy%20effects%2C%20detailed%20armor%20design%2C%20dynamic%20composition%2C%20digital%20art%2C%20clean%20neutral%20backdrop&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '一代剑神在终极决战中陨落，灵魂却穿越到少年时期。带着前世的记忆和剑术，他誓要改写命运，走向真正的巅峰。',
    tags: ['重生', '剑术', '升级流', '热血'],
    chapters: 124,
    updateDate: '2026-07-31',
    views: 2350000,
  },
  {
    id: 3,
    title: '秘密花园',
    author: '朴智恩',
    category: '悬疑',
    categorySlug: 'mystery',
    status: '连载中',
    rating: 8.9,
    cover: 'https://readdy.ai/api/search-image?query=A%20mystery%20thriller%20Korean%20manhwa%20cover%20showing%20a%20woman%20standing%20before%20a%20mysterious%20garden%20gate%20at%20twilight%2C%20eerie%20atmosphere%2C%20dark%20silhouettes%2C%20foggy%20ambience%2C%20warm%20muted%20colors%2C%20suspenseful%20mood%2C%20digital%20illustration%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '搬进新家的第一天，她就发现了后院那座被高墙围绕的秘密花园。花园里埋葬的秘密，正一步步将她卷入一场危险的谜局。',
    tags: ['推理', '都市', '反转', '烧脑'],
    chapters: 52,
    updateDate: '2026-08-01',
    views: 890000,
  },
  {
    id: 4,
    title: '武林第一高手',
    author: '崔民浩',
    category: '动作',
    categorySlug: 'action',
    status: '已完结',
    rating: 9.1,
    cover: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20Korean%20manhwa%20cover%20depicting%20a%20skilled%20fighter%20in%20dynamic%20action%20pose%20mid%20strike%2C%20traditional%20Asian%20martial%20arts%20theme%2C%20ink%20wash%20painting%20style%20blended%20with%20modern%20digital%20art%2C%20dramatic%20lighting%2C%20warm%20earthy%20tones%2C%20clean%20background&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '无名小卒陆远在山中苦修十年，下山后才发现自己的实力已经远超当世所有武林高手。轻松幽默的武侠冒险就此展开。',
    tags: ['武侠', '搞笑', '无敌流', '江湖'],
    chapters: 200,
    updateDate: '2026-06-15',
    views: 4100000,
  },
  {
    id: 5,
    title: '我的邻居是吸血鬼',
    author: '韩素希',
    category: '惊悚',
    categorySlug: 'thriller',
    status: '连载中',
    rating: 8.7,
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20manhwa%20cover%20with%20a%20mysterious%20elegant%20vampire%20character%20in%20modern%20setting%2C%20gothic%20aesthetic%20mixed%20with%20contemporary%20fashion%2C%20moody%20atmosphere%2C%20deep%20red%20and%20dark%20color%20palette%2C%20dramatic%20shadows%2C%20clean%20digital%20illustration&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '搬到首尔的新公寓后，郑秀雅发现隔壁那位英俊神秘的邻居似乎只在夜晚出门。一场人与吸血鬼之间危险又浪漫的故事。',
    tags: ['吸血鬼', '都市', '浪漫', '暗黑'],
    chapters: 38,
    updateDate: '2026-08-01',
    views: 720000,
  },
  {
    id: 6,
    title: '爆笑校园日记',
    author: '郑多彬',
    category: '搞笑',
    categorySlug: 'comedy',
    status: '连载中',
    rating: 9.0,
    cover: 'https://readdy.ai/api/search-image?query=A%20colorful%20lighthearted%20Korean%20manhwa%20cover%20with%20funny%20school%20life%20characters%2C%20bright%20vibrant%20colors%2C%20comical%20expressions%2C%20high%20school%20setting%2C%20playful%20cartoon%20style%2C%20warm%20and%20cheerful%20atmosphere%2C%20clean%20simple%20background%2C%20digital%20illustration&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '四个性格迥异的高中生，在校园里上演着令人捧腹的日常。从考试作弊到暗恋学长，每一天都是一场新的爆笑冒险。',
    tags: ['校园', '日常', '友情', '四格'],
    chapters: 156,
    updateDate: '2026-07-30',
    views: 1800000,
  },
  {
    id: 7,
    title: '千年之恋',
    author: '李知恩',
    category: '古风',
    categorySlug: 'historical',
    status: '连载中',
    rating: 9.4,
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20historical%20Korean%20manhwa%20cover%20featuring%20a%20couple%20in%20traditional%20hanbok%20clothing%2C%20ancient%20Korean%20palace%20setting%2C%20romantic%20atmosphere%2C%20cherry%20blossoms%2C%20soft%20warm%20colors%2C%20elegant%20painting-like%20style%2C%20refined%20composition%2C%20digital%20art&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '现代女孩因一场意外穿越到朝鲜王朝，与一位年轻的王世子相遇。跨越千年的爱情，能否冲破命运的阻隔？',
    tags: ['穿越', '古装', '宫廷', '虐恋'],
    chapters: 95,
    updateDate: '2026-07-28',
    views: 2100000,
  },
  {
    id: 8,
    title: '治愈咖啡厅',
    author: '孙艺珍',
    category: '治愈',
    categorySlug: 'healing',
    status: '连载中',
    rating: 9.3,
    cover: 'https://readdy.ai/api/search-image?query=A%20warm%20cozy%20Korean%20manhwa%20cover%20depicting%20a%20charming%20small%20cafe%20interior%20with%20soft%20sunlight%20streaming%20through%20windows%2C%20coffee%20and%20pastries%2C%20gentle%20atmosphere%2C%20pastel%20warm%20tones%2C%20relaxing%20vibe%2C%20clean%20minimal%20composition%2C%20digital%20illustration%20with%20soft%20edges&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '在喧闹都市的角落，有一家名为「时光」的咖啡厅。每位走进这里的客人，都能用一杯咖啡换一个温暖的故事。',
    tags: ['温馨', '日常', '咖啡', '短篇'],
    chapters: 48,
    updateDate: '2026-08-01',
    views: 650000,
  },
];

export const featuredComicIds = [2, 7, 1, 6];

export const latestUpdates = [
  { comicId: 1, chapterTitle: '第86话 最后的告白', updateTime: '2小时前' },
  { comicId: 3, chapterTitle: '第52话 花园深处的秘密', updateTime: '3小时前' },
  { comicId: 8, chapterTitle: '第48话 最后一杯拿铁', updateTime: '4小时前' },
  { comicId: 5, chapterTitle: '第38话 月圆之夜', updateTime: '5小时前' },
  { comicId: 2, chapterTitle: '第124话 剑神降临', updateTime: '昨天' },
  { comicId: 7, chapterTitle: '第95话 王世子的抉择', updateTime: '3天前' },
  { comicId: 6, chapterTitle: '第156话 期末考试大作战', updateTime: '2天前' },
  { comicId: 4, chapterTitle: '第200话 天下第一（大结局）', updateTime: '6月15日' },
];

export const banners = [
  {
    id: 1,
    comicId: 2,
    title: '重生之绝世剑神',
    subtitle: '全网热度第一 · 9.5分超高评价',
    description: '一代剑神陨落重生，带着前世记忆改写命运',
    bgImage: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20landscape%20with%20a%20lone%20warrior%20silhouette%20standing%20on%20a%20mountain%20cliff%20holding%20a%20glowing%20sword%2C%20dramatic%20sunset%20sky%20with%20golden%20and%20crimson%20clouds%2C%20ancient%20temple%20ruins%20in%20distance%2C%20cinematic%20lighting%2C%20epic%20scale%2C%20atmospheric%2C%20digital%20art%20masterpiece&width=1600&height=700&seq=banner-01&orientation=landscape',
  },
  {
    id: 2,
    comicId: 7,
    title: '千年之恋',
    subtitle: '口碑爆款 · 9.4分催泪神作',
    description: '跨越时空的宫廷虐恋，命中注定的千年之约',
    bgImage: 'https://readdy.ai/api/search-image?query=Beautiful%20ancient%20Korean%20palace%20at%20sunset%20with%20cherry%20blossom%20petals%20drifting%2C%20traditional%20architecture%2C%20romantic%20atmosphere%2C%20soft%20golden%20light%2C%20dreamy%20ethereal%20quality%2C%20cinematic%20composition%2C%20warm%20color%20palette%2C%20digital%20art&width=1600&height=700&seq=banner-02&orientation=landscape',
  },
  {
    id: 3,
    comicId: 4,
    title: '武林第一高手',
    subtitle: '200话已完结 · 爽快武侠巨作',
    description: '十年磨一剑，出山即无敌，轻松搞笑的武侠冒险',
    bgImage: 'https://readdy.ai/api/search-image?query=Martial%20arts%20master%20standing%20atop%20a%20misty%20mountain%20peak%20in%20traditional%20Chinese%20martial%20arts%20setting%2C%20flowing%20robes%2C%20ancient%20training%20ground%2C%20ink%20wash%20painting%20aesthetic%20blended%20with%20modern%20digital%20art%2C%20atmospheric%20fog%2C%20warm%20earthy%20tones&width=1600&height=700&seq=banner-03&orientation=landscape',
  },
];

export function getComicById(id: number) {
  return comics.find(c => c.id === id) || null;
}

export function getComicsByCategory(slug: string) {
  return comics.filter(c => c.categorySlug === slug);
}

export function getFeaturedComics() {
  return featuredComicIds.map(id => getComicById(id)).filter(Boolean);
}

export function getLatestUpdatesWithComics() {
  return latestUpdates.map(update => {
    const comic = getComicById(update.comicId);
    return { ...update, comic };
  }).filter(item => item.comic);
}